
export default function SliderIcon() {
  return (
<svg width="29" height="5" viewBox="0 0 29 5" fill="none" xmlns="http://www.w3.org/2000/svg">
<title>slider-menu</title>
<rect x="0.553711" y="0.834961" width="11.8733" height="3.95778" rx="1.97889" fill="#FBFBFB"/>
<rect x="16.3848" y="0.834961" width="3.95778" height="3.95778" rx="1.97889" fill="#FBFBFB" fill-opacity="0.3"/>
<rect x="24.3008" y="0.834961" width="3.95778" height="3.95778" rx="1.97889" fill="#FBFBFB" fill-opacity="0.3"/>
</svg>
  )
}
